import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import styles from './delete-stage.dialog.module.scss';
type DeleteStageDialogProps = {
  onCancel: () => void;
  onSubmit: () => void;
  stageName: string;
  stepsCount: number;
};

export const DeleteStageDialog: React.FC<DeleteStageDialogProps> = ({
  onCancel,
  onSubmit,
  stageName,
  stepsCount,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const hasSteps = stepsCount > 0;

  const handleSubmit = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      await onSubmit();
      setIsLoading(false);
      onCancel();
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      title="Delete stage"
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="delete"
          isLoading={isLoading}
          disabled={isLoading || (hasSteps && !isConfirmed)}
          onClick={handleSubmit}
          text="Yes, delete"
          variant="danger"
        />,
      ]}
    >
      <p className={styles['text']}>
        Are you sure you want to delete <strong>{stageName}</strong>?
      </p>

      {hasSteps && (
        <label className={styles['confirm-label']}>
          <input
            type="checkbox"
            checked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
          />
          <span>
            I understand that all {stepsCount} step{stepsCount > 1 ? 's' : ''} in this stage will be
            permanently deleted.
          </span>
        </label>
      )}
    </Dialog>
  );
};
